module.exports = __webpack_public_path__ + "static/media/node.99fa4653.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/frontend/node.png
// module id = 1531
// module chunks = 0